import { render, staticRenderFns } from "./ViStudentLeaveRequest.vue?vue&type=template&id=49569d90&scoped=true"
import script from "./ViStudentLeaveRequest.vue?vue&type=script&lang=js"
export * from "./ViStudentLeaveRequest.vue?vue&type=script&lang=js"
import style0 from "./ViStudentLeaveRequest.vue?vue&type=style&index=0&id=49569d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49569d90",
  null
  
)

export default component.exports